import React, { useEffect, useState } from 'react';
import './OrganizationTree.css';
import axiosInstance from '../utills/axiosInstance';

const OrganizationTree = () => {
  const [treeData, setTreeData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axiosInstance.get('/api/emptrees');

        if (response.data.success) {
          const structuredTree = buildTree(response.data.originalImages);
          setTreeData(structuredTree);
        } else {
          throw new Error(response.data.message || 'Failed to fetch data');
        }
      } catch (err) {
        setError('No Employee Data Available');
        console.error('Org tree fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const buildTree = (originalImages) => {
    const map = {};

    originalImages.forEach((image) => {
      map[image.firstName] = { ...image, children: [] };
    });

    originalImages.forEach((image) => {
      if (image.primaryReportingManager && map[image.primaryReportingManager]) {
        map[image.primaryReportingManager].children.push(map[image.firstName]);
      }
    });

    return Object.values(map).filter((node) => !node.primaryReportingManager);
  };

  return (
    <>
      <div className="tree-container">
        <h1 className="tree-header">Organization Tree View</h1>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : treeData.length === 0 ? (
          <p>No organization data available.</p>
        ) : (
          <div>
            {treeData.map((node) => (
              <TreeNode key={node._id} node={node} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

const TreeNode = ({ node }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const renderTreeNodes = (nodes) => {
    return nodes.map((childNode) => (
      <TreeNode key={childNode._id} node={childNode} />
    ));
  };

  return (
    <div className={`node ${node.children.length > 0 ? 'has-children' : ''}`}>
      {node.primaryReportingManager && (
        <div className="node-line"></div>
      )}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button onClick={toggleExpand} className="node-button">
          {isExpanded ? '[-]' : '[+]'}
        </button>
        <strong className="node-strong">{node.firstName}</strong>
        {/* {node.primaryReportingManager && (
          <span className="node-title">{` (Reports to: ${node.primaryReportingManager})`}</span>
        )} */}
        {node.designation && (
          <span className="node-title">{` (${node.designation})`}</span>
        )}
      </div>
      {isExpanded && node.children.length > 0 && (
        <div className="node-children">{renderTreeNodes(node.children)}</div>
      )}
    </div>
  );
};

export default OrganizationTree;
